// ============================================================================
// ARABIC TRANSLATIONS - JESUS IS NOT
// ============================================================================
// توضيحات لاهوتية حول يسوع (التأكيد على المحبة الشاملة)

export const jesusIsNotAr = [
  {
    category: "الشمولية",
    text: "يسوع ليس عنصرياً",
    reference: "يوحنا 4: 9",
    context: "يسوع تحدث مع المرأة السامرية، متجاوزاً حواجز العرق والثقافة"
  },
  {
    category: "الشمولية",
    text: "يسوع ليس حصرياً",
    reference: "متى 11: 28",
    context: "إنه يدعو الجميع ولا يرفض أي قلب صادق"
  },
  {
    category: "المحبة",
    text: "يسوع لا يحب بشروط",
    reference: "رومية 5: 8",
    context: "مات من أجلنا بينما كنا خطاة"
  },
  {
    category: "الرحمة",
    text: "يسوع لم يأت للدينونة فقط",
    reference: "يوحنا 3: 17",
    context: "هدفه الأساسي هو خلاص العالم"
  },
  {
    category: "الشمولية",
    text: "يسوع ليس لشعب واحد فقط",
    reference: "يوحنا 10: 16",
    context: "له خراف أخرى من كل الأمم"
  },
  {
    category: "إمكانية الوصول",
    text: "يسوع ليس للنخبة",
    reference: "مرقس 2: 17",
    context: "كان مع المرضى والفقراء والمهمشين"
  },
  {
    category: "الرحمة",
    text: "يسوع ليس غير متسامح",
    reference: "لوقا 23: 34",
    context: "حتى على الصليب، غفر"
  },
  {
    category: "المحبة",
    text: "يسوع ليس غير مبالٍ",
    reference: "متى 9: 36",
    context: "عندما رأى الجموع، تحنن عليهم بعمق"
  },
  {
    category: "الشمولية",
    text: "يسوع ليس متحيزاً ضد المرأة",
    reference: "يوحنا 20: 17",
    context: "احترم النساء واختارهن كأول شهود للقيامة"
  },
  {
    category: "الرحمة",
    text: "يسوع ليس عنيفاً",
    reference: "متى 5: 39",
    context: "علّم السلام واللاعنف"
  },
  {
    category: "إمكانية الوصول",
    text: "يسوع ليس بعيداً",
    reference: "متى 28: 20",
    context: "وعد أن يكون معنا إلى انقضاء الدهر"
  },
  {
    category: "الشمولية",
    text: "يسوع ليس لطبقة واحدة فقط",
    reference: "يعقوب 2: 1-9",
    context: "لا محاباة عنده بين الأغنياء والفقراء"
  },
  {
    category: "المحبة",
    text: "يسوع ليس فقط غضب",
    reference: "يوحنا 13: 1",
    context: "أحبنا إلى المنتهى"
  },
  {
    category: "الرحمة",
    text: "يسوع ليس شرعياً متزمتاً",
    reference: "مرقس 2: 27",
    context: "قال إن السبت صُنع لأجل الإنسان، لا الإنسان لأجل السبت"
  },
  {
    category: "الشمولية",
    text: "يسوع لا ينتمي إلى تقليد ديني واحد",
    reference: "يوحنا 4: 21-24",
    context: "يعلّم العبادة الشاملة بالروح والحق"
  },
  {
    category: "إمكانية الوصول",
    text: "يسوع لا يطلب طقوساً دينية معقدة",
    reference: "متى 18: 3",
    context: "يطلب إيماناً بسيطاً كالطفل"
  },
  {
    category: "المحبة",
    text: "يسوع لا يحمل ضغينة",
    reference: "1 بطرس 2: 23",
    context: "عندما شُتم لم يكن يشتم عوضاً"
  },
  {
    category: "الرحمة",
    text: "يسوع ليس قمعياً",
    reference: "متى 11: 30",
    context: "نيره هيّن وحمله خفيف"
  },
  {
    category: "الشمولية",
    text: "يسوع لا يميز بحسب العمر",
    reference: "مرقس 10: 14",
    context: "يرحب بالأطفال ويحترم كبار السن"
  },
  {
    category: "المحبة",
    text: "يسوع لم يأت ليدين الخطاة",
    reference: "يوحنا 8: 11",
    context: "قال للمرأة الزانية: 'وأنا لا أدينك'"
  }
];

export default jesusIsNotAr;
